import { SET_MODAL } from './types';

export default (payload: unknown) => ({
  type: SET_MODAL,
  payload,
});
